import { parseOwnedMentionUrl } from '#pplx/frontend/apps/ask/skills/utils/mentionLinkUrl.js';
import { toPublicWebUrl } from '#pplx/frontend/common/location.js';
import { validateUuid } from '#pplx/frontend/common/validateUuid.js';
const PLUGINS_PATH = '/computer/plugins';
// Mirrors the skill service's plugin id prefix (pplx/go/pkg/skillservice/plugin/id.go).
const PLUGIN_ID_PREFIX = 'plugin_';
export function getPluginPagePath(pluginId) {
    return `${PLUGINS_PATH}/${encodeURIComponent(pluginId)}`;
}
export function getPluginMentionURL(pluginId) {
    return toPublicWebUrl(getPluginPagePath(pluginId));
}
// Only server-minted ids qualify, so free text in the path stays a plain link and out of analytics.
function isPluginId(value) {
    return value.startsWith(PLUGIN_ID_PREFIX) && validateUuid(value.slice(PLUGIN_ID_PREFIX.length));
}
function decodePathSegment(segment) {
    try {
        return decodeURIComponent(segment);
    }
    catch {
        return null;
    }
}
export function getPluginMentionTarget(rawUrl) {
    const url = parseOwnedMentionUrl(rawUrl);
    if (!url)
        return null;
    const pathname = url.pathname.replace(/\/+$/, '');
    if (!pathname.startsWith(`${PLUGINS_PATH}/`))
        return null;
    const segments = pathname.slice(`${PLUGINS_PATH}/`.length).split('/');
    if (segments.length > 1)
        return null;
    const pluginId = decodePathSegment(segments[0] ?? '');
    return pluginId && isPluginId(pluginId) ? { pluginId } : null;
}
//# sourceMappingURL=getPluginMentionURL.js.map